export const REPORTS_SECTION_EVENT = 'canvas-agent:reports:section';
export const REPORTS_CREATE_MODAL_EVENT = 'canvas-agent:reports:create-modal';
export const REPORTS_FILTER_EVENT = 'canvas-agent:reports:filter';
export const REPORTS_FOCUS_EVENT = 'canvas-agent:reports:focus';
export const REPORTS_EDIT_MODAL_EVENT = 'canvas-agent:reports:edit-modal';
export const REPORTS_DELETE_MODAL_EVENT = 'canvas-agent:reports:delete-modal';
export const SENSOR_MODE_SECTION_EVENT = 'canvas-agent:sensor-mode:section';
